window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.SplashAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Foreground_Splash = function() {
	this.initialize(img.SplashAssets_Foreground_Splash);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1332,2108);


(lib.LongerMainButtonDis = function() {
	this.initialize(img.SplashAssets_LongerMainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonDown = function() {
	this.initialize(img.SplashAssets_LongerMainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonHi = function() {
	this.initialize(img.SplashAssets_LongerMainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonUp = function() {
	this.initialize(img.SplashAssets_LongerMainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.SplashBGPanel = function() {
	this.initialize(img.SplashAssets_SplashBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,739);


(lib.WhiteArrow = function() {
	this.initialize(img.SplashAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// tf
	this.textfield1 = new cjs.Text("Font", "120px 'Poppins'", "#FF0000");
	this.textfield1.name = "textfield1";
	this.textfield1.lineHeight = 211;
	this.textfield1.lineWidth = 353;
	this.textfield1.parent = this;
	this.textfield1.setTransform(90.8,47.45);
ranj.TextOffsetFixer.fix(this.textfield1);

	this.timeline.addTween(cjs.Tween.get(this.textfield1).wait(1));

	// tf
	this.textfield2 = new cjs.Text("Font ", "60px 'Poppins'");
	this.textfield2.name = "textfield2";
	this.textfield2.lineHeight = 106;
	this.textfield2.lineWidth = 282;
	this.textfield2.parent = this;
	this.textfield2.setTransform(95.4,73.75);
ranj.TextOffsetFixer.fix(this.textfield2);

	this.timeline.addTween(cjs.Tween.get(this.textfield2).wait(1));

	// tf
	this.textfield2_1 = new cjs.Text("Font ", "30px 'Poppins'", "#FF6600");
	this.textfield2_1.name = "textfield2_1";
	this.textfield2_1.lineHeight = 53;
	this.textfield2_1.lineWidth = 93;
	this.textfield2_1.parent = this;
	this.textfield2_1.setTransform(97.75,86.9);
ranj.TextOffsetFixer.fix(this.textfield2_1);

	this.timeline.addTween(cjs.Tween.get(this.textfield2_1).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AAAAAIAAH0AH0AAIn0AAAAAnzIAAHzInzAA");
	this.shape.setTransform(100,100);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,45.5,1091.3,905.7), null);


(lib.LoadingBarFront = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(4,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarFront, new cjs.Rectangle(0,0,8,6), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667.4,-1055,1334.9,2110), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("ApjAeIAAg7ITHAAIAAA7g");
	this.shape.setTransform(61.2,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0,122.4,6), null);


(lib.StartGameButtonWide = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 386;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-97,-36);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 386;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-97,-36);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 386;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-97,-36);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 386;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-97,-36);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.LongerMainButtonUp();
	this.instance_1.setTransform(-309,-63);

	this.instance_2 = new lib.LongerMainButtonHi();
	this.instance_2.setTransform(-309,-63);

	this.instance_3 = new lib.LongerMainButtonDown();
	this.instance_3.setTransform(-311,-63);

	this.instance_4 = new lib.LongerMainButtonDis();
	this.instance_4.setTransform(-310,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-311,-63,520,126);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.startbutton = new lib.StartGameButtonWide();
	this.startbutton.name = "startbutton";
	this.startbutton.setTransform(365.45,626.3,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.startbutton).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("In this game you help a team develop newiiii", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(68.35,460.6473,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Life is Sweet", "bold 144px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 154;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.SplashBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,739), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_99 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(99).call(this.frame_99).wait(1));

	// Layer_3 copy
	this.instance = new lib.LoadingBarFront();
	this.instance.setTransform(6,5,1,1,0,0,0,4,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:287},99).wait(1));

	// LoadingBarBar
	this.instance_1 = new lib.LoadingBarBar();
	this.instance_1.setTransform(6,2,0.0082,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:2.2875},99).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(6,5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(100));

	// Layer_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A2GAyQgUAAgPgPQgPgOAAgVQAAgUAPgOQAPgPAUAAMAsNAAAQAUAAAPAPQAPAOAAAUQAAAVgPAOQgPAPgUAAg");
	this.shape_1.setTransform(146.5,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,293,10);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// loadingTextField
	this.loadingTextField = new cjs.Text("loading", "13px 'Poppins Medium'", "#FFFFFF");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 23;
	this.loadingTextField.lineWidth = 289;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(0,746.05,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-403,688,2.7273,2.7273);

	this.text = new cjs.Text("", "13px 'Roboto-Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 16;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(-210,555.85);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text},{t:this.loadingBar},{t:this.loadingTextField}]}).wait(1));

	// title and body
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// versionTextField
	this.versionTextField = new cjs.Text("v1.0.12 commitslug", "italic 14px 'Roboto'", "#999999");
	this.versionTextField.name = "versionTextField";
	this.versionTextField.textAlign = "right";
	this.versionTextField.lineHeight = 17;
	this.versionTextField.lineWidth = 199;
	this.versionTextField.parent = this;
	this.versionTextField.setTransform(515.65,803.55,2.7273,2.7273);
ranj.TextOffsetFixer.fix(this.versionTextField);

	this.timeline.addTween(cjs.Tween.get(this.versionTextField).wait(1));

	// bg
	this.instance = new lib.Foreground_Splash();
	this.instance.setTransform(-665,-1054);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


// stage content:
(lib.SplashAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.text = new cjs.Text("Don't remove this movieclip! ", "24px 'Poppins Medium'", "#999900");
	this.text.lineHeight = 42;
	this.text.lineWidth = 392;
	this.text.parent = this;
	this.text.setTransform(-124,-560.05);
ranj.TextOffsetFixer.fix(this.text);

	this.instance = new lib.TextSamplesSkin();
	this.instance.setTransform(-200.2,-554.6);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(1,1,1,3,true).p("Egk/gZfMBJ/AAAMAAAAy/MhJ/AAAg");
	this.shape.setTransform(68.8,-433.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance},{t:this.text}]}).wait(1));

	// Layer 1
	this.instance_1 = new lib.SplashLoadScreenSkin();
	this.instance_1.setTransform(538.8,872,1,1,0,0,0,-1.2,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(371,273.2,836,1651.8);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/Background_Blue.png", id:"SplashAssets_Background_Blue", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/Foreground_Splash.png", id:"SplashAssets_Foreground_Splash", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonDis.png", id:"SplashAssets_LongerMainButtonDis", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonDown.png", id:"SplashAssets_LongerMainButtonDown", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonHi.png", id:"SplashAssets_LongerMainButtonHi", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/LongerMainButtonUp.png", id:"SplashAssets_LongerMainButtonUp", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/SplashBGPanel.png", id:"SplashAssets_SplashBGPanel", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/WhiteArrow.png", id:"SplashAssets_WhiteArrow", bundle:"SplashAssets"}
	],
	preloads: []
};



})(lib.SplashAssets = {}, images, ss, createjs);
module.exports = lib.SplashAssets;